import React, { useRef, useEffect } from "react";
import classNames from "classnames";

import classes from "./RightPane.scss";
import MiddleContainer from "./components/MiddleContainer";
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import FocusTrapWrapper from "UIComponents/FocusTrapWrapper/FocusTrapWrapper";

const RightPane = ({
  showRightPane,
  rightPaneStyle = {},
  rightPaneHeaderStyle = {},
  rightPaneMiddleContainerStyle = {},
  title,
  toggleRightPane,
  rightPaneData,
  titleClass = "text-heading-5",
  disableCloseOnBackdrop = false,
  crossButtonProps,
  headerSubtitle,
  bodyComponent = null,
}) => {
  const containerClass = classNames({
    [classes.container]: true,
    [classes.visible]: showRightPane,
    [classes.hidden]: !showRightPane,
  });

  const rightPaneRef = useRef(null);

  const handleClickOutside = e => {
    if (!rightPaneRef?.current?.contains(e.target)) {
      if (showRightPane && !disableCloseOnBackdrop) toggleRightPane(e);
    }
  };

  useEffect(() => {
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [showRightPane]);

  return (
    <FocusTrapWrapper isActive={showRightPane}>
      <div
        className={classes.rightPaneContainer}
        style={rightPaneStyle}
        ref={rightPaneRef}
      >
        <div className={containerClass}>
          {title && showRightPane ? (
            <div className={classes.headerParentContainer}>
              <div
                className={classes.rightPaneHeaderContainer}
                style={rightPaneHeaderStyle}
              >
                <div className={titleClass}>{title}</div>
                <IconButton
                  size={"medium"}
                  variant={"plain"}
                  icon={<CloseOutlined />}
                  onClick={toggleRightPane}
                  {...crossButtonProps}
                />
              </div>

              {headerSubtitle ? headerSubtitle : null}
            </div>
          ) : null}

          {bodyComponent ? bodyComponent : null}

          <MiddleContainer
            rightPaneData={rightPaneData}
            rightPaneMiddleContainerStyle={rightPaneMiddleContainerStyle}
          />
        </div>
      </div>
    </FocusTrapWrapper>
  );
};

export default RightPane;
